import React from 'react';

function Star({ w, h }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={w}
      height={h}
      fill='none'
      viewBox={`0 0 ${w} ${h}`}
    >
      <g>
        <path
          fill='color(display-p3 0.9373 0.8667 0.6235)'
          fillOpacity='1'
          d='M5.825 21l1.625-7.025L2 9.25l7.2-.625L12 2l2.8 6.625 7.2.625-5.45 4.725L18.175 21 12 17.275 5.825 21z'
        ></path>
      </g>
    </svg>
  );
}

export default Star;
